import React from 'react';
import SyntaxHighlighter, { registerLanguage } from 'react-syntax-highlighter/prism-light';
import { okaidia } from 'react-syntax-highlighter/styles/prism';
// Supported languages to highlight
import css from 'react-syntax-highlighter/languages/prism/css';
import js from 'react-syntax-highlighter/languages/prism/javascript';
import json from 'react-syntax-highlighter/languages/prism/json';
import jsx from 'react-syntax-highlighter/languages/prism/jsx';
import markup from 'react-syntax-highlighter/languages/prism/markup';
import scss from 'react-syntax-highlighter/languages/prism/scss';


registerLanguage('css', css);
registerLanguage('javascript', js); // handles "js" and "javascript"
registerLanguage('json', json);
registerLanguage('jsx', jsx);
registerLanguage('markup', markup); // handles "xml", "html", "svg", and "mathml"
registerLanguage('scss', scss);


const CodeBlock = ({ language, value }) => {
	// `language` can be null
	language = language ? language.toLowerCase() : null;

	// Currently using "codepen" as a special "language" to render a codepen embed.
	// In this case, the `value` is just the CodePen language markup
	if (language === 'codepen') {
		return <div className="post-codepen-embed" dangerouslySetInnerHTML={{ __html: value }} />
	}

	return (
		<SyntaxHighlighter
			language={language}
			style={okaidia}
			// showLineNumbers
		>
			{value}
		</SyntaxHighlighter>
	);
};

export default CodeBlock;



// WEBPACK FOOTER //
// ./src/ui/CodeBlock.jsx